<div class="w-full flex h-auto xl:h-screen">
  <div
    class="xl:col-7 col-12 h-auto xl:h-full flex align-items-center justify-content-center"
  >
    <div class="w-full py-2 md:px-8">
      <div class="flex flex-column gap-4 p-4">
        <div class="flex align-items-center justify-content-between gap-2">
          <div class="w-full max-w-8rem">
            <a [routerLink]="['/home']">
              <img
                src="../../../assets/images/logo.svg"
                alt=""
                class="w-full"
              />
            </a>
          </div>
          <!-- <a href="#" class="w-auto px-5 py-2 border-2 border-round-lg border-indigo-800 text-indigo-800 hover:text-white hover:bg-indigo-800">Sign In</a> -->
        </div>

        <div class="flex flex-column gap-2">
          <h1 class="text-4xl lg:text-6xl font-bold">Become a Mentor</h1>
          <p>
            Get started below
            <!-- <a [routerLink]="['/find-a-mentor']"
              class="text-blue-700 hover:text-blue-400 hover:underline">GradPilots.com</a> -->
          </p>
        </div>
        <form #userForm="ngForm" (ngSubmit)="onSubmit(userForm)">
          <ul class="flex flex-column gap-3">
            <!--Social Media SignUp-->
            <!-- <li>
                  <dl class="flex gap-2 flex-column sm:flex-row sm:gap-4">
                    <dt class="flex-1 flex flex-column gap-2 ">
                      <a href="#" class="flex align-items-center justify-content-center gap-2 px-3 py-3 border-2 border-round-lg hover:bg-indigo-100">
                        <span class="block" style="width: 24px;">
                            <img src="../../../assets/icons/google-in.svg" alt="" class="block w-full">
                        </span>
                        <p class="font-normal">Continue with <span class="font-medium">Google</span></p>
                      </a>
                    </dt>
                    <dt class="flex-1 flex flex-column gap-2">
                      <a href="#" class="flex align-items-center justify-content-center gap-2 px-3 py-3 border-2 border-round-lg hover:bg-indigo-100">
                        <span class="block" style="width: 24px;">
                            <img src="../../../assets/icons/linked-in.svg" alt="" class="block w-full">
                        </span>
                        <p class="font-normal">Continue with <span class="font-medium">LinkedIn</span></p>
                      </a>
                    </dt>
                  </dl>
                </li> -->
            <!-- <li>
                  <dl class="flex gap-4  flex-column sm:flex-row">
                    <dt class="flex-1 flex flex-column gap-2">
                      <label for="">First Name</label>
                      <input type="text" pInputText />
                    </dt>
                    <dt class="flex-1 flex flex-column gap-2">
                      <label for="">Last Name</label>
                      <input type="text" pInputText />
                    </dt>
                  </dl>
                </li> -->
            <li class="flex flex-column gap-2">
              <label for="">Email Address</label>
              <input
                type="text"
                pInputText
                [(ngModel)]="email"
                #emailInput="ngModel"
                name="email"
                required
                pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                class="input"
              />
              <small
                *ngIf="emailInput.dirty && emailInput.invalid"
                class="ng-dirty ng-invalid text-left text-sm text-red-500"
              >
                <ng-container *ngIf="!userForm.value.email"
                  >Email is required</ng-container
                >
                <ng-container *ngIf="userForm.value.email && emailInput.errors"
                  >Enter a valid Email</ng-container
                >
              </small>
            </li>
            <li *ngIf="otpSent">
              <label>OTP</label>
              <p-inputOtp
                #otpInput="ngModel"
                [(ngModel)]="otp"
                name="otp"
                [length]="6"
                [invalid]="true"
                [integerOnly]="true"
                required
              />
              <small
                *ngIf="otpInput.dirty && otpInput.invalid"
                class="ng-dirty ng-invalid text-left text-sm text-red-500"
              >
                OTP is required
              </small>
            </li>
            <!-- <li class="flex flex-column gap-2">
                      <label for="">Password</label>
                      <input type="password" pInputText />
                  </li> -->
            <li class="flex flex-column gap-2">
              <p-button
                label="Continue"
                type="submit"
                [loading]="loading"
                styleClass="login_btn"
                [disabled]="userForm.invalid"
              />
              <!-- <p class="text-center pt-3">By Signing up, you agree to our <a href="#" class="text-blue-700 hover:text-blue-400 hover:underline">Terms of Use</a> and <a href="#" class="text-blue-700 hover:text-blue-400 hover:underline">Privacy Policy</a>.</p> -->
              <p class="text-center pt-3">
                Already registerd?
                <a
                  href="partner-signin"
                  class="text-blue-700 hover:text-blue-400 hover:underline"
                  >Sign in now</a
                >.
              </p>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
  <div
    class="h-full lg:col-5 xl:flex align-items-center justify-content-center loginWrapper_right hidden"
  >
    <div class="logo">
      <img src="../../../assets/images/logo.svg" alt="" />
    </div>
  </div>
</div>
